import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { homeModule } from './modules/home';
import { catalogGraphModule } from './modules/catalogGraph';
import { dataTableModule } from './modules/dataTable';
import { appModuleNav } from './modules/appModuleNav';
import { appModuleScaffolder } from './modules/appModuleScaffolder';
import { appModuleSignInPage } from './modules/appModuleSignInPage';
import { appModuleTheme } from './modules/appModuleTheme';

export default createApp({
  features: [
    catalogPlugin,
    homeModule,
    catalogGraphModule,
    dataTableModule,
    appModuleNav,
    appModuleScaffolder,
    appModuleSignInPage,
    appModuleTheme,
  ],
});
